import config from 'config'
import { ProductSettings } from 'types/ProductSettings'
import { fetchWithToken } from 'utils'
import externalAdminFiltersToString from './externalAdminFiltersToString'

/**
 * Retrieves the settings for given product
 */
const fetchProductSettings = async (accountKey: string, product: string): Promise<ProductSettings> =>
  await fetchWithToken({
    method: 'GET',
    useV5: false,
    useVersion: '',
    baseUrl: config.EXTERNAL_ADMIN_URL,
    resource: `ext-admin/rest/accounts/${accountKey}`,
    path: `products/${product.toLowerCase()}/settings`,
    filters: externalAdminFiltersToString({}),
  })
    .then((response: Response) => response.json())
    .catch((err: Error) => {
      // Something wrong happened during the fetch
      console.error(err.toString())
    })

export default fetchProductSettings
